class SpecialRoles {
  constructor() {
    this.importantRoles = [
      // benj local
      '64747d27590114366cfb3378', // developer
      '640e2576a182d997b178d265', // director
      '640e2576a182d997b178d263', // admin

      // intranet (PGC local server) (temporary)
      // '64747d27590114366cfb3378', // developer
      // '64b09e156bab11c405880d70', // director
      // '64b09e156bab11c405880d6c' // admin
    ];
  }

  async validateRole(user) {
    return new Promise((res) => {
      const dept = this.importantRoles.find((sr) => user.roles.includes(sr));
      res(dept);
    });
  }
}

export default SpecialRoles;
